module.exports = __webpack_public_path__ + "img/step-3.5340ba7.jpg";